var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-tabs',[_c('v-tab',[_vm._v(" Administración de Usuarios ")]),_c('v-tab-item',[_c('UserAdministrationView')],1),_c('v-tab',[_vm._v(" Acceso a Cuentas ")]),_c('v-tab-item',[_c('UserAccountAdministrationView')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }